
import { forwardRef, useEffect, useMemo, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";
import { commonFormFields } from "../../FeuConstants";
import { useParams } from "react-router";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";
const FeuC17ZeroEmissions = forwardRef(({ c17ZeroEmissionTechnology, refetchMonitoringData,vesselMstId }, ref) => {

    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);
    const savedValuesRef = useRef({});
    const { dirtyFields } = formState;
    const isC17Dirty = !!(dirtyFields?.c17 && Object.keys(dirtyFields.c17).length > 0);

    useEffect(() => {
        if (c17ZeroEmissionTechnology) {
            reset(prev => ({ ...prev, c17: c17ZeroEmissionTechnology }));
        }
    }, [c17ZeroEmissionTechnology, reset]);


    const c17Fields = useMemo(() => {
        return commonFormFields.reduce((acc, field) => {
            if (field.name === "dataSources") return acc;
            if (field.name === "descriptionOfProcedure") {
                acc.push({
                    ...field,
                    label:
                        "Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
                });
            } else {
                acc.push(field);
            }
            return acc;
        }, []);
    }, []);

    AutoSave(ref, [], async () => {
        const currentValues = getValues("c17");
        const isChanged = Object.keys(currentValues || {}).some(
            key => currentValues[key] !== savedValuesRef.current?.[key]
        );
        if (!isC17Dirty || !isChanged) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c17");
        const payload = {
            ...c17Fields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const C17ZeroEmissionTechnology = await callApi({
                method: "POST",
                url: API_ROUTES.C17(vesselMstId),
                data: payload,
            });
            if (C17ZeroEmissionTechnology?.isSuccess) {
                emitToasterMsg("success", "Table C.1.7", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c1: formValues }));
                savedValuesRef.current = { ...formValues };
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.1.7", C17ZeroEmissionTechnology?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.1.7", error.errorMessage);
        }
    };


    return (
        <div className="b7-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Monitoring energy provided by a zero emission technology</h6>
                </MDBCol>
            </MDBRow>
            {c17Fields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c17.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c17_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c12_save_btn"
                    disabled={!isC17Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >Save</Button>
            </div>
        </div>
    );

})

export default FeuC17ZeroEmissions;